import React from 'react'

import { useTranslation } from 'react-i18next'
import { useLoaderData } from 'react-router-dom'

import BasicPlanCard from '@features/compare-plans/BasicPlanCard'
import EduPlanCard from '@features/compare-plans/EduPlanCard'
import PremiumPlanCard from '@features/compare-plans/PremiumPlanCard'
import PageLayout from '@layout/PageLayout'

import type { PlansLoaderResponse } from '@pages/plans/plans.loader'

const PlansPage: React.FC = () => {
  const { t } = useTranslation()
  const { premiumPricing, eduPricing } = useLoaderData() as PlansLoaderResponse

  return (
    <PageLayout hideFooter>
      <div className="mb-8 flex w-full flex-col items-center pt-6 lg:pt-10">
        <h1 className="mb-4 px-5 text-center font-semibold text-[40px] lg:text-[48px]">
          {t('content.plans.title')}
        </h1>
        <h3 className="mb-6 px-5 text-center text-lg font-medium lg:mb-12">
          {t('content.plans.subtitle')}
        </h3>
        <div className="mx-4 flex flex-col items-start gap-4 lg:flex-row xl:gap-9">
          <BasicPlanCard />
          <PremiumPlanCard premiumPricing={premiumPricing} />
          <EduPlanCard eduPricing={eduPricing} />
        </div>
      </div>
    </PageLayout>
  )
}

export default PlansPage
